/**
 * The delivery form on its own page.
 *
 * A worker taps "Record a delivery" and is in the form — no list to scroll
 * past, no dialog to open. The location comes from where they are working, so
 * the one question nobody at a counter should be asked is which branch they
 * are standing in.
 */

import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecordLocation } from '../../lib/locationContext';
import { Card, EmptyState } from '../../components/ui';
import { PageHeader } from '../../layouts/AppShell';
import { DeliveryEntryForm } from './DeliveryEntryForm';

export function NewDeliveryPage(): ReactNode {
  const navigate = useNavigate();
  const location = useRecordLocation();

  if (location.unresolved) {
    return (
      <>
        <PageHeader title="Record a delivery" />
        <Card>
          <EmptyState
            title="No location to record against"
            description="Ask the owner to assign you to the place you work."
          />
        </Card>
      </>
    );
  }

  return (
    <>
      <PageHeader title="Record a delivery" description="The job you have just done." />
      <Card>
        <div className="p-4">
          <DeliveryEntryForm
            branchId={location.branchId}
            onDone={() => navigate('/deliveries')}
            onCancel={() => navigate(-1)}
          />
        </div>
      </Card>
    </>
  );
}
